module.exports = __webpack_public_path__ + "static/img/Campbell-Graham.7ede493.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Campbell-Graham.jpg
// module id = /BZC
// module chunks = 0